import { render, staticRenderFns } from "./fileUpdataReview.vue?vue&type=template&id=0c85875a&scoped=true&"
import script from "./fileUpdataReview.vue?vue&type=script&lang=js&"
export * from "./fileUpdataReview.vue?vue&type=script&lang=js&"
import style0 from "./fileUpdataReview.vue?vue&type=style&index=0&id=0c85875a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85875a",
  null
  
)

export default component.exports